import React, { FC, ReactNode } from 'react';
import { Card } from 'antd';
import { WidgetEmpty, WidgetError, WidgetSkeleton } from './WidgetStates';

interface Props {
  title: string;
  isLoading?: boolean;
  isError?: boolean;
  isEmpty?: boolean;
  onRetry?: () => void;
  height?: number;
  extra?: ReactNode;
  children: ReactNode;
}

export const ChartCard: FC<Props> = ({
  title,
  isLoading,
  isError,
  isEmpty,
  onRetry,
  height = 300,
  extra,
  children,
}) => (
  <Card title={title} extra={extra} className="h-100">
    {isError ? (
      <WidgetError height={height} onRetry={onRetry} />
    ) : isLoading ? (
      <WidgetSkeleton height={height} />
    ) : isEmpty ? (
      <WidgetEmpty height={height} />
    ) : (
      children
    )}
  </Card>
);
